export default {
  'component.photofinish.title': 'Boligfoto',
  'component.photofinish.heading1': 'Takk for din bestilling!',
  'component.photofinish.heading1.description':
    'Fotografen vil kontakte deg for å ordne ytterligere detaljer. Når bestillingen er fullført, vil fotografen laste opp bildene, og du finner alle tilgjengelige bilder her. Klikk på OK for å gå tilbake til hovedsiden.',
};
